import React, { Component } from "react";
import { Spin, message, Radio, Space, Checkbox, DatePicker } from "antd";
import Bridge from "../../../utils/Bridge";
import {
  speech_consent_form_content,
  le_study_demographics_form_type,
} from "../../../utils/consts";
import moment from "moment";
import dayjs from "dayjs";
import { RESEARCH_TYPE } from "../../../utils/consts";

export default class ConsentFormChild extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      is_consent_form_signed: false,
      neurostamp_id: "",
      modality_id: "",
      email: "",
      i_accept_checkbox: false,
      consent_form_date: "",
      readInSpanish: false,
    };
  }
  componentDidMount() {
    if (RESEARCH_TYPE == "LE Study") {
      if (localStorage.getItem("ap_language") == "Spanish only") {
        this.setState({ readInSpanish: true });
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params =
      "?participants_accounts_id=" +
      localStorage.getItem("ap_participants_accounts_id") +
      "&type=" +
      le_study_demographics_form_type.consent_form +
      "&eals_id=" +
      localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Consent form signed?") {
                if (item.value == "Yes") {
                  this.setState({ i_accept_checkbox: item.value });
                  this.props.set_active_step(1);
                }
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  save_details = () => {
    if (!this.state.i_accept_checkbox) {
      message.warning("Please accept the consent form");
      return;
    }
    if (!this.state.consent_form_date) {
      message.warning("Please select consent form date");
      return;
    }
    let questions = [
      {
        parent_field: "Consent form signed?",
        field: "Consent form signed?",
        value: "Yes",
      },
      {
        parent_field: "Consent form signed Date",
        field: "Consent form signed Date",
        value: this.state.consent_form_date
          ? moment(this.state.consent_form_date).format("YYYY-MM-DD")
          : "",
      },
    ];
    let params = {
      data: JSON.stringify(questions),
      step: le_study_demographics_form_type.consent_form,
      email: this.state.email,
      participants_accounts_id: localStorage.getItem(
        "ap_participants_accounts_id"
      ),
      eals_id: localStorage.getItem("ap_eals_id"),
      type: le_study_demographics_form_type.consent_form,
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              // window.location.assign('/dashboard')
              // if (present_non_als == true) {
              this.props.set_active_step(1);
              //   this.props.set_non_als_user(present_non_als);
              // } else {
              //   this.props.set_active_step(8);
              //   this.props.set_non_als_user(present_non_als);
              // }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  logout = () => {
    localStorage.clear();
    window.location.assign("/");
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>CONSENT FORM</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group pdf-div">
              <iframe
                src="./assets/documents/ecas-study-consent-form.pdf#toolbar=0"
                title="Consent Form"
                width="100%"
                height="600px"
              ></iframe>
            </div>
            <div className="form-group">
              <Checkbox
                value={"Yes"}
                onChange={(event) =>
                  this.setState({ i_accept_checkbox: event.target.checked })
                }
                checked={this.state.i_accept_checkbox == true ? true : false}
                style={{ fontSize: 17 }}
              >
                I Accept <span className="text-danger">*</span>
              </Checkbox>
            </div>
            <div className="form-group col-lg-5 pl-0">
              <label
                htmlFor="consent-form-date mb-2"
                style={{ fontSize: 17, marginBottom: 10 }}
              >
                Consent Form Date <span className="text-danger">*</span>
              </label>
              <DatePicker
                id="consent-form-date"
                className="form-control"
                onChange={(date, dateString) =>
                  this.setState({ consent_form_date: dateString })
                }
                format="MM/DD/YYYY"
                disabledDate={(current) =>
                  current && current > moment().endOf("day")
                }
              />
            </div>
            <button
              className="submit-button"
              style={{ padding: "9px 15px 10px 20px" }}
              onClick={() => this.save_details()}
            >
              Save & Next{" "}
              <box-icon
                name="chevron-right"
                color="#fff"
                style={{ position: "relative", top: 1 }}
              ></box-icon>
            </button>
          </div>
        </Spin>
      </div>
    );
  }
}
